

Shopify.enable_namagoo = false;
Shopify.cart_item_count = function () {
  $.getJSON('/cart.js', function(cart){
    var cartCount = cart.item_count;
    $(".header__cart-count").html(cartCount);
    $('.header__cart-count.header__cart-count--floating.bubble-count').text(cartCount);
    })
};

var userSource = "";
function quickATC() {
    let e = $(".quick-buy-product").parents(".product-item__info ").find(".product-item-meta__title").text(),
        t = $(".quick-buy-product").parents(".product-item__info ").find(".price--highlight").text().split("price")[1];
    var i = $(".color-swatch__radio:checked").val();
        setTimeout(function () {
            $(".drawer--quick-buy").attr("open", !1), $(".header__cart").attr("aria-expanded", !0);
        }, 1200);
}
(userSource = navigator.userAgent.includes("Mobile") ? "Mobile" : navigator.userAgent.includes("iPad") ? "Tablet" : "Desktop"),
    $(".featured-collections").on("click", function () {
        let e = $(this).siblings(".section__header").find('.tabs-nav__item[aria-expanded="true"]').text();
    }),
    $(".product-item__quick-form").on("click", function () {
        let e = $(this).parents(".product-item__info").find(".product-item-meta__title").text(),
            t = $(this).parents(".product-item__info").find(".price--highlight").text().split("price")[1];
    }),
    $("#mini-cart-form").submit(function () {
        var e = $(".cart-total").val(),
            t = "",
            i = [];
        $("#mini-cart .line-item").each(function (e, n) {
            var o = $(this).find(".product-item-meta__title").text(),
                r = $(this).find(".product-item-meta__title").attr("data-product_id"),
                c = $(this).find(".price--highlight").text().split("price")[1],
                a = $(this).find(".product-item-meta__title").attr("data-product_type"),
                l = $(this).find(".quantity-selector__input").val();
            (t = 0 == e ? o : t + "," + o), i.push({ item_name: o, item_id: r, price: c, item_category: a, quantity: l });
        })
    }),
    $(".footer__item-content .linklist__item").each(function () {
        $(this).on("click", function () {
            let e = $(this).text().trim();
        });
    }),
    $(".header__inline-navigation .header__linklist-item").each(function () {
        $(this).on("click", function () {
            let e = $(this).attr("data-item-title").trim();
        });
    }),
    window.matchMedia("(max-width: 767px)").matches &&
        ($(".footer__item-title").append('\n  <span class="expanded toggle">+</span>\n  <span class="collapsed visually-hidden toggle">-</span>\n  '),
        $(".footer__item--links").click(function () {
            $(this).find(".footer__item-content").slideToggle(), $(this).find("span.toggle").toggleClass("visually-hidden");
        })),
    $(".myDropdown .toggle-link").click(function () {
        $(".myDropdown .dropdown-menu").removeClass("visually-hidden");
    }),
    $(".myDropdown .close-popup").click(function () {
        $(".myDropdown .dropdown-menu").addClass("visually-hidden");
    }),
    $(document).click(function (e) {
        e.stopPropagation(), 0 === $(".myDropdown").has(e.target).length && $(".dropdown-menu").addClass("visually-hidden");
    }),
    $("collapsible-content .mobile-nav .mobile-nav__item").each(function () {
        $(this).on("click", function () {
            let e = $(this).text().trim();
        });
    });
let currentURL = location.href,
    cartStr = "/cart",
    cartHashStr = "/#cart";
-1 != currentURL.indexOf(cartStr) && (location.href = "/#cart"),
    -1 != currentURL.indexOf(cartHashStr) && $(".header__cart").attr("aria-expanded", !0),
    $("button.press-list__logo-item.tap-area").hover(function () {
        $(this).trigger("click");
    }),
    $(".product-item").each(function () {
        $(this).find(".meta-label-new-arrival").length && $(this).find(".lowest-price ").remove();
    })

let unitsLeft = '';
let usual_price = '';

Shopify.variantChange = function (e) {
  var product_form = event.target;
  if (!e.available) {
    console.log(e.available, 'show notify me');
    // $('.custom-notify-btn').show();
    $('.out_of_stock_msg').show();
    $('.pincode_checker_heading').hide();
    $('.pdp_right_section .payment_offers').hide();
    $('.product__info button#AddToCart').hide();
    product_form.querySelector('#AddToCart') ? product_form.querySelector('#AddToCart').classList.add('hide_cTA') : '';
    product_form.querySelector('.cutomized-btn') ? product_form.querySelector('.cutomized-btn').classList.add('hide_cTA') : '';
    product_form.querySelector('.button.custom-prebook') ? product_form.querySelector('.button.custom-prebook').classList.add('hide_cTA') : '';
    product_form.querySelector('.pdp-custom-payment-container') ? product_form.querySelector('.pdp-custom-payment-container').classList.add('hide_cTA') : '';
    // $('quick-buy-drawer #AddToCart').hide();
    // $('quick-buy-popover #AddToCart').hide();
    product_form.querySelector('.custom_notifyMe_btn') ? product_form.querySelector('.custom_notifyMe_btn').classList.add('show_notifyMe') : '';
    $('.product-item__quick-form.quick-buy-notify-me #notifyMe_trigger').attr('data-variant-id', e.id);
    $('.d-lg-none.current-in-cart, .desktop.current-in-cart, .offer-callout-simple, .popup_wrapper').hide();
    $('.d-lg-none.restocking, .desktop.restocking').show();
    $('.pincode_checker_container').hide();
    if ($('#notifyMe_trigger.custom-notify-btn').length > 0) {
      $('#notifyMe_trigger.custom-notify-btn').attr('data-variant-id', e.id);
      var varient_url = $('#notifyMe_trigger.custom-notify-btn').attr('data-url');
      varient_url = varient_url.split('?')[0];
      varient_url = varient_url + "?variant=" + e.id;
      $('#notifyMe_trigger.custom-notify-btn').attr('data-url', varient_url);
    }
    setTimeout(() => {
      $('.flash-sale-lable').hide()
    }, 10)

  } else {
    console.log(e.available, 'hide notify me');
    // $('.custom-notify-btn').hide();
    $('.out_of_stock_msg').hide();
    $('.pincode_checker_heading').show();
    $('.product__info .product-form__add-button').show();
    $('.pdp_right_section .payment_offers').show();
    product_form.querySelector('#AddToCart') ? product_form.querySelector('#AddToCart').classList.remove('hide_cTA') : '';
    product_form.querySelector('.cutomized-btn') ? product_form.querySelector('.cutomized-btn').classList.remove('hide_cTA') : '';
    product_form.querySelector('.button.custom-prebook') ? product_form.querySelector('.button.custom-prebook').classList.remove('hide_cTA') : '';
    product_form.querySelector('.pdp-custom-payment-container') ? product_form.querySelector('.pdp-custom-payment-container').classList.remove('hide_cTA') : '';
    // $('quick-buy-drawer #AddToCart').show();
    // $('quick-buy-popover #AddToCart').show();
    product_form.querySelector('.custom_notifyMe_btn') ? product_form.querySelector('.custom_notifyMe_btn').classList.remove('show_notifyMe') : '';
    $('.d-lg-none.current-in-cart, .desktop.current-in-cart, .offer-callout-simple, .popup_wrapper').show();
    $('.d-lg-none.restocking, .desktop.restocking').hide();
    $('.pincode_checker_container').show();
    var variant_personalization = sessionStorage.getItem('variant_personalization');
    variant_personalization = JSON.parse(variant_personalization);
    for (var key in variant_personalization) {
      if (variant_personalization.hasOwnProperty(e.id)) {
        $('.personalization-image-wrapper img').attr('src', variant_personalization[e.id]);
        break;
      }
    }
  }
  $('.pdp-btn-price').remove();
  //let compare_price =  ( ${e.price / 100} *100 ) / ${e.compare_at_price / 100} ;

  let regular_price = e.compare_at_price / 100;
  let sale_price = e.price / 100;
  let discount_percentage;

  if (regular_price > sale_price) {
    discount_percentage = Math.round(((regular_price - sale_price) / regular_price) * 100) + '% Off';
  } else {
    discount_percentage = ''
  }
  $("#AddToCart.a2c .loader-button__text, .cutomized-btn .loader-button__text, #AddToCart.prebook .loader-button__text").html('');
  $("#AddToCart.a2c .loader-button__text, .cutomized-btn .loader-button__text").append(`
<span class="atc_btn">
<svg id="Group_211011" data-name="Group 211011" xmlns="http://www.w3.org/2000/svg" width="19.725" height="20" viewBox="0 0 19.725 23">
  <path id="Rectangle_760" data-name="Rectangle 760" d="M8.558,5.081a.8.8,0,1,0,1.6,0ZM0,5.081a.8.8,0,1,0,1.6,0ZM5.081,1.6A3.477,3.477,0,0,1,8.558,5.081h1.6A5.081,5.081,0,0,0,5.081,0Zm0-1.6A5.081,5.081,0,0,0,0,5.081H1.6A3.477,3.477,0,0,1,5.081,1.6Z" transform="translate(4.78)" fill="#fff"/>
  <path id="Rectangle_788" data-name="Rectangle 788" d="M.836,13.108l.8.1Zm18.053,0-.8.1h0ZM17.819,4.55l.8-.1h0Zm-15.913,0-.8-.1ZM6.152,1.6h7.421V0H6.152ZM17.023,4.65l1.07,8.558,1.592-.2-1.07-8.558Zm-2.38,12.466H5.082v1.6h9.561ZM1.632,13.208,2.7,4.65l-1.592-.2L.04,13.009Zm3.45,3.908a3.477,3.477,0,0,1-3.45-3.908l-1.592-.2A5.081,5.081,0,0,0,5.082,18.72Zm13.011-3.908a3.477,3.477,0,0,1-3.45,3.908v1.6a5.081,5.081,0,0,0,5.042-5.712ZM13.573,1.6a3.477,3.477,0,0,1,3.45,3.045l1.592-.2A5.081,5.081,0,0,0,13.573,0ZM6.152,0A5.081,5.081,0,0,0,1.11,4.451l1.592.2A3.477,3.477,0,0,1,6.152,1.6Z" transform="translate(0 4.28)" fill="#fff"/>
</svg>                    
<span class="add_to_cart_btn">Add to cart</span>
</span>
<span class="pdp-btn-price custom_price_wrapper">
<span class="inclusive_text_content">Inclusive of all Taxes</span>
<span class="mobile_atc_btn">
  <span class="mobile_atc_price">₹${e.price / 100}</span>
  <span class="saved_price">${discount_percentage}</span>
</span>
</span>`);

  $("#AddToCart.prebook .loader-button__text").append(`
<span class="atc_btn">
<span class="add_to_cart_btn">Pre-order</span>
</span>
<span class="pdp-btn-price custom_price_wrapper">
<span class="inclusive_text_content">Inclusive of all Taxes</span>
<span class="mobile_atc_btn">
  <span class="mobile_atc_price">₹${e.price / 100}</span>
  <span class="saved_price">${discount_percentage}</span>
</span>
</span>`);
  //  console.log(e);

  function swatches_change(varient_swatches_input) {
    for (let i = 0; i < varient_swatches_input.length; i++) {

      if (varient_swatches_input[i].checked) {
        $.ajax({
          url: location.pathname + "?variant=" + e.id + "&section_id=main-product",
          type: "GET",
          dataType: "html",
          success: function (e) {
            var product_media = $(e).find('product-media').html();
            $("product-media").html(product_media);
            setTimeout(function () {
              var product_itemsDiv = '.product_media_section .MultiCarousel-inner';
              var product_itemsMainDiv = ('.product_media_section .MultiCarousel');
              var product_selector = 'MultiCarousel_product';
              Shopify.product_slider(product_itemsDiv, product_itemsMainDiv, product_selector);
              if ($('.MultiCarousel_loaded.MultiCarousel-inner .product__media-item').length < 2) {
                $(product_itemsMainDiv).addClass('hide_dots');
              } else {
                $(product_itemsMainDiv).removeClass('hide_dots');
              }
              $('.product__media-image-wrapper img').click(function () {
                $('.product__zoom-button').click();
              });
              $('button.product__thumbnail-item.hidden-pocket').hover(function () {
                $(this).trigger('click');
              });
            }, 500);
          }
        })


      }
    }
  }
  let varient_swatches_input = document.querySelectorAll('.variant-swatch input');
  swatches_change(varient_swatches_input);
  let color_swatches_input = document.querySelectorAll('.color-swatch input');
  swatches_change(color_swatches_input)
}

// # info: Collection Filters Code
Shopify.accordion = function(tablinks) {
  for (i = 0; i < tablinks.length; i++) {
      if (tablinks[i].hasAttribute("open")) {
          tablinks[i].removeAttribute("open");
          tablinks[i].previousElementSibling.setAttribute('aria-expanded', 'false');
      }
  }
}

function preserveQuery() {
  Shopify.queryParams = {};
  if (window.location.search.length) {
      const params = window
          .location
          .search
          .substr(1)
          .split('&');
      const filterParams = params.filter(checkPrice);
      const fliterUrl = params.filter(priceNotInclude);

      function checkPrice(param) {
          return param.includes('filter.v.price');
      }

      function priceNotInclude(param) {
          return !param.includes('filter.v.price');
      }

      let fliterBaseUrl = fliterUrl.toString();
      fliterBaseUrl = fliterBaseUrl.replaceAll(',', '&')
      Shopify.fliterUrl = fliterBaseUrl;
      for (let i = 0; i < filterParams.length; i++) {
          const keyValue = filterParams[i].split('=');

          if (keyValue.length) {
              Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
          }
      }
  }

}

function triggerEvent(element, name, data = {}) {
  element.dispatchEvent(new CustomEvent(name, {
      bubbles: true,
      detail: data
  }));
}

Shopify.collectionFilter = function(filterLoad) {

  let details = document.querySelectorAll("#facet-filters-form collapsible-content");
  let summary = $('#facet-filters-form .collapsible-toggle');

  summary.click(function() {
      Shopify.accordion(details);
      $(this).attr('aria-expanded', 'true');
      $(this).siblings('collapsible-content').attr('open', 'true');
  });

  preserveQuery();

  let sortItems = document.querySelectorAll('.price-tag-filter .tag');
  for (let i = 0; i < sortItems.length; i++) {
      sortItems[i].addEventListener('click', function(e) {
          preserveQuery();
          Shopify.queryParams['filter.v.price.gte'] = e.target.attributes['data-min'].value;
          Shopify.queryParams['filter.v.price.lte'] = e.target.attributes['data-max'].value;
          let searchParams = new URLSearchParams(Shopify.queryParams).toString();
          if (Shopify.fliterUrl) {
              searchParams = `${Shopify.fliterUrl}&${searchParams}`
          }
          triggerEvent(this, "facet:criteria-changed", {
              url: `${window.location.pathname}?${searchParams}`
          });

      })
  }
  if (filterLoad) {
      Shopify.accordion(details);
      if (summary[0] != undefined) {
          summary[0].setAttribute('aria-expanded', 'true');
          summary[0].nextElementSibling.setAttribute('open', 'true');
      }
  }
}

let collectionFilterLoad = true;
Shopify.collectionFilter(collectionFilterLoad);

const date = new Date()
options = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  hour12: true
};
const LOGIN_TIMESTAMP = new Intl.DateTimeFormat("en-GB", options).format(date);

$(document).on("click", ".custom-offer-add-to-cart", function (e) {
  e.preventDefault();
  let offerForm = $(this).parents("form")[0];
  let offerId = offerForm.querySelector('[name="id"]').value;
  let data = { 'quantity': 1, 'id': offerId }
    $.ajax({
      url: "/cart/add.js",
      dataType: "json",
      cache: !1,
      type: "post",
      data: data,
      success: function (e) {
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: !0
        }));
        setTimeout(function () {
          Shopify.cart_item_count();
        }, 1500)
      }
    })
});

Shopify.varient_view_popup = function(varient_id, btn) {
  var varient_view_popup_close_btn = btn;
  document.addEventListener("click", function (event) {
    var varient_view_popup_container = document.querySelector(".pdp-360-view_container");
    if (varient_view_popup_container != null && !varient_view_popup_container.contains(event.target) && event.target !== varient_view_popup_close_btn) {
      $('.pdp-360-view').removeClass('show');
      $('body').removeClass('overflow-hidden');
      document.querySelector('.pdp-360-view_body').innerHTML = '';
    }
  });
  $.ajax({
    url: location.pathname + "?variant=" + varient_id + "&view=3D_view",
    type: "GET",
    dataType: "html",
    success: function(e) {
        $(".pdp-360-view_body").html(e);
          $('.pdp-360-view').addClass('show');
          $('body').addClass('overflow-hidden');
          let popup_detail = $('.pdp_view_popup_item');
        $('.pdp_view_popup_btn_container button').click(function(){
        var index = $(this).attr('data-index');
          for (i = 0; i < popup_detail.length; i++) {
            if (popup_detail[i].hasAttribute("open")) {
              popup_detail[i].removeAttribute("open");
            }
          }
          $('.pdp_view_popup_btn_container button').removeAttr('active');
          $(this).attr('active', 'true');
          popup_detail[index].setAttribute('open', 'true');
        });
    }
  })
  }

  $(document).on("click", ".pdp-custom-cta-button", function(e) {
    e.preventDefault();
    let id = $(this).parents('.pdp-inner').find('form [name="id"]').val();
    id = parseInt(id);
    let quantity = $(this).attr('data-qty');
    quantity = parseInt(quantity);
    $.ajax({
        url: "/cart/add.js",
        dataType: "json",
        cache: !1,
        type: "post",
        data: {id: id,quantity: quantity},
        success: function(e) {
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                bubbles: !0
            })), document.getElementById("mini-cart").open = !0,
                Shopify.cart_item_count()
        }
    })
  });
